import React, { useEffect } from 'react'
import { fetchUserInfo } from './stores/async/async-actions'
import { useUser } from './stores/user/user.hooks'
import { useDispatch } from 'react-redux'

export function SvberAuthenticator({ children }) {
    const user = useUser()
    const dispatch = useDispatch()

    useEffect(() => {
        // Get SSO-user's info every minute
        dispatch(fetchUserInfo())
        const interval = setInterval(() => dispatch(fetchUserInfo()), 60_000)
        return () => clearInterval(interval);
    }, [dispatch, fetchUserInfo]) // Prevents useEffect re-running with every refresh

    // Prevents children components from prematurely showing while waiting for fetchUserInfo to dispatch.
    if (!user?.email) return <>Loading...</>;

    return (<>{children}</>);
}